<div class="angularForm">
  <kendo-datepicker [(ngModel)]="internalModel"
                    [format]="dateFormat"
                    [disabled]="ngReadonly"
                    (ngModelChange)="modelChanged()"
                    [popupSettings]="{ popupClass: 'angularForm' }"
                    placeholder="">
  </kendo-datepicker>
</div>
